import { render, staticRenderFns } from "./StatsUserAccess.vue?vue&type=template&id=84e18dec&"
import script from "./StatsUserAccess.vue?vue&type=script&lang=js&"
export * from "./StatsUserAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports